
    <h3 mat-dialog-title>Comment</h3>
    <mat-dialog-content>
      <textarea matInput [readonly]="readOnly" [(ngModel)]="data.comment"
                style="min-height: 150px; margin: 1px 0" class="textarea-note"></textarea>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
    <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button color="primary" class="mr-1" [hidden]="readOnly"
              (click)="dialogRef.close(data.comment)">Save
      </button>
    </mat-dialog-actions>
  